// Mock data for Sid's Deli

export const menuData = {
  sandwiches: [
    {
      id: 1,
      name: "Bacon Egg & Cheese",
      nameFr: "Bacon Egg & Cheese",
      description: "Smoked bacon, griddle eggs, cheddar cheese, sauce of choice on American roll.",
      descriptionFr: "Bacon fumé, Oeufs au plat, Cheddar, sauce au choix, Roll Americain",
      price: "8.50",
      image: "https://customer-assets.emergentagent.com/job_sids-sandwich-spot/artifacts/gav4nkel_WhatsApp%20Image%202025-12-28%20at%205.23.18%20PM%20%282%29.jpeg"
    },
    {
      id: 2,
      name: "The Royal BEC",
      nameFr: "The Royal BEC",
      description: "Smoked bacon, griddle eggs, hash brown, cheddar, sauce of choice on American roll.",
      descriptionFr: "Bacon fumé, Oeufs au plat, Galette de pomme de terre, Cheddar, Sauce au choix, Roll Americain",
      price: "10.00",
      image: "https://customer-assets.emergentagent.com/job_sids-sandwich-spot/artifacts/9r7e9824_WhatsApp%20Image%202025-12-28%20at%205.23.22%20PM%20%281%29.jpeg"
    },
    {
      id: 3,
      name: "Ham Egg & Cheese",
      nameFr: "Ham Egg & Cheese",
      description: "Ham, griddle eggs, cheddar, sauce of choice on American roll.",
      descriptionFr: "Jambon, Oeufs au plat, Cheddar, sauce au choix, Roll Americain",
      price: "8.00",
      image: "https://customer-assets.emergentagent.com/job_sids-sandwich-spot/artifacts/bly8q3zb_WhatsApp%20Image%202025-12-28%20at%205.23.18%20PM.jpeg"
    },
    {
      id: 4,
      name: "Egg & Cheese (Vegetarian)",
      nameFr: "Egg & Cheese (Végétarien)",
      description: "Griddle eggs, cheddar, sauce of choice on American roll.",
      descriptionFr: "Oeufs au plat, Cheddar, sauce au choix, Roll Americain",
      price: "6.50",
      image: "https://customer-assets.emergentagent.com/job_sids-sandwich-spot/artifacts/unoylgqa_WhatsApp%20Image%202025-12-28%20at%205.23.21%20PM%20%282%29.jpeg"
    },
    {
      id: 5,
      name: "The Reuben",
      nameFr: "The Reuben",
      description: "Pastrami, coleslaw, emmental, cocktail sauce on rye bread.",
      descriptionFr: "Pastrami, Coleslaw, Emmental, Sauce Cocktail, Pain de seigle",
      price: "13.90",
      image: "/images/pastrami.jpg"
    },
    {
      id: 8,
      name: "Philly Cheesesteak",
      nameFr: "Philly Cheesesteak",
      description: "Ribeye steak, peppers, onions, provolone, American mustard on Italian bread.",
      descriptionFr: "Steak Faux Filet, Poivron, Oignon, Provolone, Moutarde Amercaine, Pain Italien",
      price: "13.90",
      image: "https://customer-assets.emergentagent.com/job_sids-sandwich-spot/artifacts/05fo6ity_WhatsApp%20Image%202025-12-28%20at%205.23.17%20PM.jpeg"
    },
    {
      id: 9,
      name: "Batman & Robin",
      nameFr: "Batman & Robin",
      description: "Breaded chicken, homemade BBQ sauce, cheddar, smoked bacon on American roll.",
      descriptionFr: "Poulet panée, Sauce BBQ maison, Cheddar, Bacon fumé, Roll Americain",
      price: "12.90",
      image: "https://customer-assets.emergentagent.com/job_sids-sandwich-spot/artifacts/oqtlcq58_WhatsApp%20Image%202025-12-28%20at%205.23.22%20PM.jpeg"
    }
  ],
  sandwichExtras: [
    {
      id: 5,
      name: "Hash Brown",
      nameFr: "Galette de Pomme de Terre",
      price: "1.50"
    },
    {
      id: 6,
      name: "Bacon",
      nameFr: "Bacon",
      price: "2.00"
    },
    {
      id: 7,
      name: "Ham",
      nameFr: "Jambon",
      price: "1.50"
    }
  ],
  preparedSandwiches: {
    title: "Prepared Sandwiches",
    titleFr: "Sandwichs Préparés",
    description: "A variety of freshly made sandwiches available daily in our display case, ready to heat and enjoy! Including favorites like The Reuben, Club Sandwich, The 203 with homemade roast beef (fait maison), and more.",
    descriptionFr: "Une variété de sandwichs fraîchement préparés disponibles chaque jour dans notre vitrine, prêts à réchauffer et à déguster! Y compris les favoris comme The Reuben, Club Sandwich, The 203 avec roast beef fait maison, et plus encore."
  },
  sides: [
    {
      id: 10,
      name: "Fries",
      nameFr: "Frites",
      description: "Classic fries.",
      descriptionFr: "Frites classiques",
      price: "3.50",
      image: null
    },
    {
      id: 11,
      name: "Animal Fries",
      nameFr: "Animal Fries",
      description: "Classic fries, pulled pork, cheddar, homemade BBQ sauce, horseradish sauce, fried onions.",
      descriptionFr: "Frites classique, Porc effilochée, Cheddar, Sauce BBQ maison, Sauce au raifort, Oignon frits",
      price: "8.90",
      image: null
    },
    {
      id: 12,
      name: "Mac and Cheese",
      nameFr: "Mac and Cheese",
      description: "Creamy homemade mac and cheese.",
      descriptionFr: "Mac and cheese maison crémeux",
      price: "6.99",
      image: "https://customer-assets.emergentagent.com/job_sids-sandwich-spot/artifacts/rtlog8qq_WhatsApp%20Image%202025-12-28%20at%205.23.21%20PM%20%283%29.jpeg"
    },
    {
      id: 13,
      name: "BBQ Ribs",
      nameFr: "Travers de Porc BBQ",
      description: "Tender BBQ ribs with homemade sauce.",
      descriptionFr: "Travers de porc tendres avec sauce maison",
      price: "6.99",
      image: "https://customer-assets.emergentagent.com/job_sids-sandwich-spot/artifacts/liczxzlw_WhatsApp%20Image%202025-12-28%20at%205.23.20%20PM.jpeg"
    }
  ],
  desserts: [
    {
      id: 20,
      name: "Rice Krispie Treats",
      nameFr: "Rice Krispie Treats",
      description: "Classic homemade rice krispie treats.",
      descriptionFr: "Rice krispie treats maison classiques",
      price: "2.00",
      image: "https://customer-assets.emergentagent.com/job_sids-sandwich-spot/artifacts/49adj4xp_WhatsApp%20Image%202025-12-28%20at%205.23.20%20PM%20%283%29.jpeg"
    },
    {
      id: 21,
      name: "Oatmeal Raisin Cookies",
      nameFr: "Cookies Flocons d'Avoine Raisins",
      description: "Soft and chewy oatmeal raisin cookies.",
      descriptionFr: "Cookies moelleux aux flocons d'avoine et raisins",
      price: "2.00",
      image: "https://customer-assets.emergentagent.com/job_sids-sandwich-spot/artifacts/krl3sgre_WhatsApp%20Image%202025-12-28%20at%205.23.21%20PM.jpeg"
    },
    {
      id: 22,
      name: "Chocolate Brownies",
      nameFr: "Brownies au Chocolat",
      description: "Rich and fudgy chocolate brownies.",
      descriptionFr: "Brownies au chocolat riches et fondants",
      price: "2.00",
      image: "https://customer-assets.emergentagent.com/job_sids-sandwich-spot/artifacts/6nomyugb_WhatsApp%20Image%202025-12-28%20at%205.23.21%20PM%20%281%29.jpeg"
    }
  ],
  salads: []
};

export const contactData = {
  phone: "+33 5 56 28 03 35",
  email: "sidney.poidevin@sidsdeli.fr",
  instagram: "sidsdelibdx",
  address: {
    street: "9 Rue Parlement Saint-Pierre",
    city: "Bordeaux",
    country: "France",
    postalCode: "33000"
  },
  hours: {
    en: {
      monday: "Closed",
      tuesday: "Closed",
      wednesday: "12:00 PM - 9:00 PM",
      thursday: "12:00 PM - 10:00 PM",
      friday: "12:00 PM - 10:00 PM",
      saturday: "12:00 PM - 10:00 PM",
      sunday: "12:00 PM - 9:00 PM"
    },
    fr: {
      monday: "Fermé",
      tuesday: "Fermé",
      wednesday: "12h00 - 21h00",
      thursday: "12h00 - 22h00",
      friday: "12h00 - 22h00",
      saturday: "12h00 - 22h00",
      sunday: "12h00 - 21h00"
    }
  },
  mapCoordinates: {
    lat: 44.8378,
    lng: -0.5792
  }
};
